import { useUser } from '@clerk/react'
import { useCallback } from 'react'
import { useApi } from '@/lib/api'

export const DRIVE_FILE = 'https://www.googleapis.com/auth/drive.file'

type RespuestaToken = { token: string; vence: number | null } | { necesitaPermiso: true }

/**
 * El token de Google de RASTRO para el selector (Fase 6).
 *
 * `obtener()` resuelve con el token, o con `null` si la persona todavía no
 * dio el permiso de Drive. `pedirPermiso()` la lleva a Google a darlo (Clerk
 * agrega `drive.file` a su cuenta ya vinculada) y vuelve a esta misma página.
 */
export function useTokenDrive() {
  const api = useApi()
  const { user } = useUser()

  const obtener = useCallback(async (): Promise<string | null> => {
    const r = await api<RespuestaToken>('/api/drive/token')
    return 'token' in r ? r.token : null
  }, [api])

  const cuentaGoogle = user?.externalAccounts.find((c) => c.provider === 'google') ?? null

  const pedirPermiso = useCallback(async () => {
    if (!cuentaGoogle) {
      throw new Error(
        'Tu sesión no es de Google. Entrá con "Continuar con Google" para usar el selector de Drive.',
      )
    }
    const cuenta = await cuentaGoogle.reauthorize({
      additionalScopes: [DRIVE_FILE],
      redirectUrl: window.location.href,
    })
    const destino = cuenta.verification?.externalVerificationRedirectURL
    if (!destino) throw new Error('Google no devolvió a dónde ir para dar el permiso')
    window.location.href = destino.href
  }, [cuentaGoogle])

  return { obtener, pedirPermiso, tieneGoogle: Boolean(cuentaGoogle) }
}
